import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { startMessage, stopMessage } from '../../services/engage-targeting';
import { isMessagingEnabled } from '../../utils/messaging';
var CoordinationClient = /*#__PURE__*/function () {
  function CoordinationClient(configOrCloudId, stargateUrl) {
    _classCallCheck(this, CoordinationClient);
    var config;
    if (typeof configOrCloudId === 'string') {
      config = {
        cloudId: configOrCloudId,
        stargateUrl: stargateUrl,
        isFedRAMPEnvironment: false
      };
    } else {
      config = configOrCloudId;
    }
    if (!config.cloudId || !config.stargateUrl) {
      throw new Error('Need a valid CloudId and Stargate url');
    }
    this.cloudId = config.cloudId;
    this.stargateUrl = config.stargateUrl;
    this.orgId = config.orgId;
    this.workspaceId = config.workspaceId;
    this.coordinationOptions = config.coordinationOptions;
  }
  return _createClass(CoordinationClient, [{
    key: "start",
    value: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(messageId, variationId) {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (isMessagingEnabled()) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return", false);
            case 2:
              return _context.abrupt("return", startMessage({
                cloudId: this.cloudId,
                stargateUrl: this.stargateUrl,
                messageId: messageId,
                variationId: variationId,
                orgId: this.orgId,
                workspaceId: this.workspaceId
              }, this.coordinationOptions));
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function start(_x, _x2) {
        return _start.apply(this, arguments);
      }
      return start;
    }()
  }, {
    key: "stop",
    value: function () {
      var _stop = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(messageId) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (isMessagingEnabled()) {
                _context2.next = 2;
                break;
              }
              return _context2.abrupt("return", false);
            case 2:
              return _context2.abrupt("return", stopMessage({
                cloudId: this.cloudId,
                stargateUrl: this.stargateUrl,
                messageId: messageId,
                orgId: this.orgId,
                workspaceId: this.workspaceId
              }, this.coordinationOptions));
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function stop(_x3) {
        return _stop.apply(this, arguments);
      }
      return stop;
    }()
  }]);
}();
export { CoordinationClient as default };